import { useEffect, useState, useRef } from "react";
import { FaTimes, FaCloudUploadAlt, FaTrash, FaDownload } from "react-icons/fa";
import pathconfig from '../../../pathconfig.json';
import axios from "axios";
import JSZip from "jszip"; // package added by praveen, for download all the files in the attachment in single zip..
import Docx from "../../../images/icons/docx.png";
import Doc from "../../../images/icons/doc.png";
import Pdf from "../../../images/icons/pdf.png";
import Jpg from "../../../images/icons/jpg.png";
import Png from "../../../images/icons/png.png";
import Tif from "../../../images/icons/tif.png";
import Tiff from "../../../images/icons/tiff.png";
import Zip from "../../../images/icons/zip.png";
import Xml from "../../../images/icons/xml.png";
import Json from "../../../images/icons/json.png";
import Ini from "../../../images/icons/ini.png";
import Txt from "../../../images/icons/txt.png";
import Xlsx from "../../../images/icons/Xlsx.png";
import Noimage from "../../../images/icons/noimage.png";
import { toastError, toastSuccess } from '../../toaster';
import moment from 'moment';
import NodataFound from "../../nodata";
import packjson from '../../../../package.json';
import { useAppContextProvider } from '../../../contextapi';

const Attachment_Sidebar = (props) => {
  const [file, setFile] = useState([]);
  const fileInputRef = useRef(null);
  const closeBtnRef = useRef(null);
  const yesBtnRef = useRef(null);
  const firstCategoryRef = useRef(null);
  const [showconfirm, setConfirm] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  
  const [selectedFilesWithComment, setSelectedFilesWithComment] = useState([]);
  const [attachmentComment, setAttachmentComment] = useState([]);
  const [deleteData, setDeleteData] = useState('');
  const [loader, setLoader] = useState(true);
  const [zipping, setZipping] = useState(false);
  const { userProfile, setSidebarClose, alttextEnabled } = useAppContextProvider();


  useEffect(() => {
    if (props.fileItems) {
      console.log('File Items with Comments:', props.fileItems);
      setFile(props.fileItems);
      setLoader(false)
    }
  }, [props.fileItems]);

  // Auto-focus close button whenever sidebar is opened (from layout)
  useEffect(() => {    
        if (props.leftsidebarvalue === 'attachement') {
                if (closeBtnRef.current) {
                    closeBtnRef.current.focus();
                }
        }
    }, [props.leftsidebarvalue])
    
  useEffect(() => {
    if (showconfirm && yesBtnRef.current) {
      yesBtnRef.current.focus();
    }
  }, [showconfirm]);

    // Close confirmation modal on ESC key
    useEffect(() => {
      if (!showconfirm) return;
      const handleEsc = (e) => {
        if (e.key === 'Escape') {
          setConfirm(false);
        }
      };
      document.addEventListener('keydown', handleEsc);
      return () => document.removeEventListener('keydown', handleEsc);
    }, [showconfirm]);
  const handleFileSelect = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (!selectedFiles || selectedFiles.length === 0) {
      // No files selected, do nothing and ensure modal does not open
      setShowCommentModal(false);
      setSelectedFilesWithComment([]);
      setAttachmentComment([]);
      return;
    }
    const selectedFiles2 = file.filter((a) =>
      selectedFiles.some((sf) => sf.name === a.Filename)
    );
    if (selectedFiles2.length !== 0) {
      toastError('File is already exit.');
      e.target.value = null;
    } else {
      setSelectedFilesWithComment(selectedFiles);
      setShowCommentModal(true);
    }
  }
useEffect(() => {
  if (showCommentModal) {
    setTimeout(() => {
      if (firstCategoryRef.current) {
        firstCategoryRef.current.focus();
      }
    }, 50);
  }
}, [showCommentModal]);



  const handleUploadWithComment = () => {
    // Check if all selected files have a type and comment
    const missingFields = selectedFilesWithComment.filter(file => {
      const fileMetadata = attachmentComment.find(item => item.file === file.name);
      return !fileMetadata || !fileMetadata.filetype || !fileMetadata.comment || (alttextEnabled && fileMetadata.filetype === 'imageAttachment' && !fileMetadata.altTextGeneration);
    });

    if (missingFields.length > 0) {
      toastError(alttextEnabled
        ? "Please select a category, enter a comment, and (for images) choose alt-text option for all files before uploading."
        : "Please select a category and enter a comment for all files before uploading.");
      return; // Stop the upload if validation fails
    }
    // All validation passed. Trim and sanitize comments at submit time before upload.
    const sanitizeComment = (value) => {
      if (typeof value !== 'string') return '';
      // Remove HTML tags to prevent stored HTML injection
      return value.replace(/<[^>]*>/gm, '').trim();
    };
    
    setAttachmentComment(prev =>
      prev.map(item => ({ ...item, comment: sanitizeComment(item.comment) }))
    );
    // Ensure text attachments have altTextGeneration set to null
    const updatedComments = selectedFilesWithComment.map((file) => {
      const existingComment = attachmentComment.find(item => item.file === file.name) || {};
      return {
        ...existingComment,
        file: file.name,
        comment: sanitizeComment(existingComment.comment || ''),
        altTextGeneration: existingComment.filetype === 'imageAttachment' ? existingComment.altTextGeneration : null
      };
    });

    proceedWithUpload(updatedComments);
  };

  const handleAltTextChange = (filename, value) => {
    setAttachmentComment(prev =>
      prev.map(item => (item.file === filename ? { ...item, altTextGeneration: value } : item))
    );
  };

  const proceedWithUpload = (updatedComments) => {
    setLoader(true);
    props.getTrigger(false);

    try {
      let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
      let GetDetailData = JSON.parse(GetDetailDataString);
      var formdata = new FormData();

      // Add base data
      formdata.append("jobGUID", GetDetailData.Articledetails.ArticleGUID);
      formdata.append("ActivityID", GetDetailData.ActivtyDetails.ActivityID);
      formdata.append("docid", userProfile.docid);
      formdata.append("type", "attachment");

      // Validate file sizes and append data
      const oversizedFiles = [];
      const maxFileSize = 40 * 1024 * 1024; // 40MB

      selectedFilesWithComment.forEach((file, index) => {
        if (file.size > maxFileSize) {
          oversizedFiles.push(file.name);
          return;
        }

        const fileMetadata = updatedComments.find(item => item.file === file.name) || {};

        formdata.append("files", file);
        formdata.append(`fileTypes[${index}]`, fileMetadata.filetype);
        formdata.append(`fileComments[${index}]`, fileMetadata.comment);
        formdata.append("altTextGeneration[0]", alttextEnabled ? fileMetadata.altTextGeneration : null);
      });

      if (oversizedFiles.length > 0) {
        toastError(`File size should be less than 40 MB: ${oversizedFiles.join(', ')}`);
        if (oversizedFiles.length === selectedFilesWithComment.length) {
          setLoader(false);
          setShowCommentModal(false);
          setSelectedFilesWithComment([]);
          setAttachmentComment([]);
          return;
        }
      }

      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].upload_attachment}`;

      axios.post(url, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          setLoader(false);
          props.refreshAttachments(true);
          setShowCommentModal(false);
          setSelectedFilesWithComment([]);
          setAttachmentComment([]);
          // Reset file input to allow re-selection of the same file
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          if (response.data.SuccessFiles.length !== 0) {
            response.data.SuccessFiles.forEach(item =>
              toastSuccess(`${item.data[0].Filename} - ${item.message}`)
            );
          }
          if (response.data.FailedFiles.length !== 0) {
            response.data.FailedFiles.forEach(item =>
              toastError(`${item.data[0].Filename} - ${item.message}`)
            );
          }
        })
        .catch(error => {
          console.log(error);
          // Surface the backend's message (e.g. "This file format is restricted…")
          // which is returned as { error: "…" }; fall back to the generic message.
          toastError(error.response?.data?.error || error.message);
          setLoader(false);
        });

    } catch (error) {
      console.log(error);
      toastError(error.message);
      setLoader(false);
    }
  };



  // Resolve a MIME type from a filename, mirroring the Supplementary download flow.
  const getMimeTypeForFile = (filename) => {
    const ext = (filename.split('.').pop() || '').toLowerCase();
    switch (ext) {
      case 'doc': return 'application/msword';
      case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls': return 'application/vnd.ms-excel';
      case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'ppt': return 'application/vnd.ms-powerpoint';
      case 'pptx': return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
      case '7z': return 'application/x-7z-compressed';
      case 'swf': return 'application/x-shockwave-flash';
      default: return `application/${ext || 'octet-stream'}`;
    }
  };

  const handleDownloadAll = async () => {
    if (zipping) return;
    if (!file || file.length === 0) {
      toastError('No attachments to download.');
      return;
    }
    setZipping(true);
    try {
      const zip = new JSZip();
      const usedNames = {};
      let addedCount = 0;

      // Fetch each attachment directly from its SAS URL — the same source the
      // single-file download uses (the download anchor's href={item.SASFilepath}).
      await Promise.all(
        file.map(async (item) => {
          try {
            const mimeType = getMimeTypeForFile(item.Filename || '');
            const response = await axios.get(item.SASFilepath, { responseType: 'blob' });

            // Ensure unique names inside the zip if duplicates exist
            let name = item.Filename || 'attachment';
            if (usedNames[name] !== undefined) {
              usedNames[name] += 1;
              const dot = name.lastIndexOf('.');
              name = dot > 0
                ? `${name.slice(0, dot)}(${usedNames[name]})${name.slice(dot)}`
                : `${name}(${usedNames[name]})`;
            } else {
              usedNames[item.Filename || 'attachment'] = 0;
            }
            zip.file(name, new Blob([response.data], { type: mimeType }));
            addedCount += 1;
          } catch (err) {
            console.log('Failed to fetch attachment for zip:', item.Filename, err);
            toastError(`Failed to download ${item.Filename}`);
          }
        })
      );

      if (addedCount === 0) {
        toastError('Unable to download attachments.');
        return;
      }

      // Name the zip after the article/document, e.g. NEUCOM130927_attachment.zip
      let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
      let GetDetailData = JSON.parse(GetDetailDataString);
      const articleName = GetDetailData?.Articledetails?.ArticleName || 'attachments';
      const zipName = `${articleName}_attachment.zip`;

      const content = await zip.generateAsync({ type: 'blob' });
      const blobUrl = window.URL.createObjectURL(content);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = zipName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      toastSuccess('Attachments downloaded successfully');
    } catch (error) {
      console.log(error);
      toastError(error.message);
    } finally {
      setZipping(false);
    }
  };

  const deleteConfirm = (value) => {
    setDeleteData(value)
    setConfirm(true)
  }

  const deleteAttchment = () => {
    props.getTrigger(false)
    let dataValue = deleteData;
    let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
    let GetDetailData = JSON.parse(GetDetailDataString);
    let data = {
      "ArticleGUID": dataValue.ArticleGUID,
      "AttachID": dataValue.AttachID,
      "Proof_Type": GetDetailData.jobdetails.ProofType,
      "AttachFlag": dataValue.AttachFlag,
      "docid": userProfile.docid
    }
    const deleteUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].deleteAttachment}`
    axios.post(deleteUrl, data).then((response) => {
      setConfirm(false)
      props.getTrigger(true)
      props.refreshAttachments(); 
      toastSuccess(`${response.data.data[0].Filename} - ${response.data.message}`)
    }
    ).catch((error) => {
      console.log(error);
      toastError(error.message);
    })
  }

  function getFileIcon(filetype) {
    switch (filetype) {
      case "png": return Png
      case "pdf": return Pdf
      case "jpg":
      case "jpeg": return Jpg
      case "docx": return Docx
      case "doc": return Doc
      case "tiff": return Tiff
      case "tif": return Tif
      case "zip": return Zip
      case "txt": return Txt
      case "xlsx": return Xlsx
      case "json": return Json
      case "xml": return Xml
      case "ini": return Ini
      default: return Noimage
    }
  }

  const handleSelectType = (value, filename, index) => {
    const existing = attachmentComment.find(it => it.file === filename);
    let newComment = {
      file: filename,
      filetype: value,
      comment: existing?.comment || "",
      altTextGeneration: value === 'imageAttachment' ? (existing?.altTextGeneration || '') : null
    };

    // Check if the file is already present
    if (!attachmentComment.some(item => item.file === filename)) {
      setAttachmentComment([...attachmentComment, newComment]);
    } else {
      // Optional: Update the existing entry if needed
      setAttachmentComment(
        attachmentComment.map(item =>
          item.file === filename ? { ...item, filetype: value, altTextGeneration: value === 'imageAttachment' ? (item.altTextGeneration || '') : null } : item
        )
      );
    }
  };

  // Function to handle adding or updating a comment for a filename
  const handleAddComment = (comment, filename, index) => {
    const existing = attachmentComment.find(item => item.file === filename);
    let newComment = {
      file: filename,
      filetype: existing?.filetype || '',
      comment: comment || "",
      altTextGeneration: existing?.altTextGeneration !== undefined ? existing.altTextGeneration : (existing?.filetype === 'imageAttachment' ? '' : null)
    };

    // Check if the file is already present
    if (!attachmentComment.some(item => item.file === filename)) {
      setAttachmentComment([...attachmentComment, newComment]);
    } else {
      // Optional: Update the existing entry if needed
      setAttachmentComment(
        attachmentComment.map(item =>
          item.file === filename ? { ...item, comment: comment } : item
        )
      );
    }
  };

  const RoleSplit = (value) => {
    const roleArray = JSON.parse(value);
    const roleName = roleArray[0].RoleName;
    return roleName;
  }

  const getAttachmentTypeDisplay = (type) => {
    switch (type) {
      case 'imageAttachment':
        return 'Image Attachment'
      case 'textAttachment':
        return 'Text Attachment'
      case 'commentAttachment':
        return 'Comment Attachment'
      case 'mediaAttachment':
        return 'Media Attachment'
      default:
        return type
    }
  }

  return (
    <div className="attachement_area">
      <main className="slider-header">
        <h2>Attachement</h2>
        <div>
          {userProfile?.role === 'Master Copier' && (
            <button
              className="download-all-btn"
              title="Download all as zip"
              aria-label="Download all attachments as zip"
              tabIndex={0}
              disabled={zipping || file.length === 0}
              onClick={handleDownloadAll}
            >
              {zipping ? <span className="loader-small" aria-hidden="true"></span> : <FaDownload aria-hidden="true" />}
            </button>
          )}
          <button
            className="close-btn"
            title="Close"
            tabIndex={0}
            ref={closeBtnRef}
            onClick={() => {
              setSidebarClose(true);
              // After closing, focus the Attachement tab button
              setTimeout(() => {
                const attBtn = document.querySelector('button[title="Attachement Tab"]');
                if (attBtn) attBtn.focus();
              }, 0);
            }}
            onKeyDown={(e) => {
              // Support Enter/Space to activate close and then restore focus
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setSidebarClose(true);
                setTimeout(() => {
                  const attBtn = document.querySelector('button[title="Attachement Tab"]');
                  if (attBtn) attBtn.focus();
                }, 0);
              }
            }}
          >
            <FaTimes />
          </button>
        </div>
      </main>

      {/* Delete Confirmation Modal */}
      <div className={`modal-outer ${showconfirm ? "active" : ""}`}>
        <div className="modal confirmation-popup">
          <div className="modal-header">
            <h1>Confirm Delete</h1>
            <button className="modal-close-btn" tabIndex={0} aria-label="Close" onClick={() => setConfirm(false)}><FaTimes /></button>
          </div>
          <div className="modal-body">
            <p style={{ textAlign: 'center', margin: '10px 0' }}>Are you sure you want to delete this file?</p>
          </div>
          <div className="modal-footer">
            <button
              className="primary"
              tabIndex={0}
              ref={yesBtnRef}
              onClick={deleteAttchment}
            >Yes</button>
            <button
              className="outline-secondary"
              tabIndex={0}
              onClick={() => setConfirm(false)}
            >No</button>
          </div>
        </div>
      </div>
      {/* Comment Modal - Alternative UI */}
      <div className={`modal-outer ${showCommentModal ? "active" : ""}`}>
        <div className="modal att-comment-modal">
          {/* Header */}
          <div className="modal-header">
            <h1>Add Comment for Attachment</h1>
            <button
              className="modal-close-btn"
              tabIndex={0}
              aria-label="Close"
              onClick={() => {
                setShowCommentModal(false);
                setSelectedFilesWithComment([]);
                setAttachmentComment([]);
                if (fileInputRef.current) {
                  fileInputRef.current.value = null;
                }
              }}
            >
              <FaTimes />
            </button>
          </div>

          {/* Body */}
          <div className="modal-body att-modal-body">
            {selectedFilesWithComment && (
              <>
                {Array.from(selectedFilesWithComment).map((file, index) => (
                  <div className="att-file-card" key={index}>
                    <div className="att-file-card-header">
                      <div className="att-file-icon">
                        {file.name.split('.').pop().substring(0, 2).toUpperCase()}
                      </div>
                      <span title={file.name}>{file.name}</span>
                    </div>
                    <div className="att-file-card-body">
                      {/* Category */}
                      <div className="att-form-group">
                        <label className="att-form-label">
                          Category <span className="att-required">*</span>
                        </label>
                        <select
                          ref={index === 0 ? firstCategoryRef : null}
                          value={attachmentComment.find(it => it.file === file.name)?.filetype || ''}
                          onChange={(e) => handleSelectType(e.target.value, file.name, index)}
                          className="att-select"
                          required
                          tabIndex={0}
                        >
                          <option value="">-- Choose a category --</option>
                          <option value="imageAttachment">Image</option>
                          <option value="textAttachment">Text</option>
                          <option value="mediaAttachment">Media</option>
                        </select>
                      </div>

                      {/* Comment */}
                      <div className="att-form-group">
                        <label className="att-form-label">
                          Comment <span className="att-required">*</span>
                        </label>
                        <textarea
                          value={attachmentComment.find(it => it.file === file.name)?.comment || ''}
                          onChange={(e) => handleAddComment(e.target.value, file.name)}
                          onKeyDown={(e) => e.stopPropagation()}
                          placeholder="Enter comment for attachment"
                          required
                          className="att-textarea"
                          tabIndex={0}
                        />
                      </div>

                      {/* Alt text options for images (only when alttextEnabled) */}
                      {alttextEnabled && userProfile.role === "Author" && attachmentComment.find(it => it.file === file.name)?.filetype === 'imageAttachment' && (
                        <div className="att-form-group">
                          <div className="att-alt-section">
                            <div className="att-alt-header">
                              {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9-3a1 1 0 11-2 0 1 1 0 012 0zM6.75 7.75a.75.75 0 000 1.5h.5V11a.75.75 0 001.5 0V8.5a.75.75 0 00-.75-.75h-1.25z" fill="#333"/></svg> */}
                              Alternative text option <span className="att-required">*</span>
                            </div>
                            <div className="att-alt-body">
                              <label
                                className={`att-alt-option ${attachmentComment.find(it => it.file === file.name)?.altTextGeneration === 'yes' ? 'att-selected' : ''}`}
                              >
                                <input
                                  type="radio"
                                  name={`alt-${index}`}
                                  value="yes"
                                  checked={attachmentComment.find(it => it.file === file.name)?.altTextGeneration === 'yes'}
                                  onChange={() => handleAltTextChange(file.name, 'yes')}
                                  required
                                />
                                <div className="att-alt-option-text">
                                  <strong>Add/replace with a completely new image</strong>
                                  <span>A new alt-text needs to be generated.</span>
                                </div>
                              </label>

                              <label
                                className={`att-alt-option ${attachmentComment.find(it => it.file === file.name)?.altTextGeneration === 'no' ? 'att-selected' : ''}`}
                              >
                                <input
                                  type="radio"
                                  name={`alt-${index}`}
                                  value="no"
                                  checked={attachmentComment.find(it => it.file === file.name)?.altTextGeneration === 'no'}
                                  onChange={() => handleAltTextChange(file.name, 'no')}
                                />
                                <div className="att-alt-option-text">
                                  <strong>Upload the same image in higher resolution</strong>
                                  <span>Retain the previously generated alt-text</span>
                                </div>
                              </label>

                              <div className="att-info-banner">
                                <svg className="att-info-icon" width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm9-3a1 1 0 11-2 0 1 1 0 012 0zM6.75 7.75a.75.75 0 000 1.5h.5V11a.75.75 0 001.5 0V8.5a.75.75 0 00-.75-.75h-1.25z" fill="#0c5aa8"/></svg>
                                <span>If only the resolution changed (low to high), new alt text may not be required.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              className="primary"
              tabIndex={0}
              onClick={handleUploadWithComment}
            >
              Upload
            </button>
            <button
              className="outline-secondary"
              tabIndex={0}
              onClick={() => {
                setShowCommentModal(false);
                setSelectedFilesWithComment([]);
                setAttachmentComment([]);
                if (fileInputRef.current) {
                  fileInputRef.current.value = null;
                }
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      
      <div className="upload-area">
        <button
          className="upload-btn-wrapper"
          aria-label="File Upload"
        onKeyDown={e => {
          if (e.key === 'Tab' && !e.shiftKey && file.length === 0) {
            e.preventDefault();
            const tocBtn = document.getElementById('toc-tab-btn');
            if (tocBtn) tocBtn.focus();
            return;
          }
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (fileInputRef.current) fileInputRef.current.click();
            return;
          }
        }}
        >
          <label htmlFor="file-upload" style={{ display: 'contents' }}>
            <FaCloudUploadAlt aria-hidden="true" />
            <p>Choose file or drag here</p>
          </label>
          <input
            id="file-upload"
            type="file"
            onChange={handleFileSelect}
            multiple
            ref={fileInputRef}
          />
        </button>

        <section className="upload-list-area" aria-label="Uploaded files list">
          {loader ? (
            <div className="fileupload-loder">
              <span className="loader" aria-hidden="true"></span>
            </div>
          ) : null}
          {file.length !== 0 ? (
            file.map((item, index) => (
              <div className="upload-list-area-inner" key={index}>
                <div className="icons-details">
                  <div className="upload-icons">
                    <img src={getFileIcon(item.filetype)} alt={item.filetype} />
                  </div>
                  <div className="upload-details" style={{lineHeight: "20px"}}>
                    <p aria-label={`filename:${item.Filename}`} tabIndex={0} title={item.Filename}>{item.Filename}</p>
                    <label aria-label={`username:${item.username}`} tabIndex={0}>{item.username}</label>
                    <span>
                      Date: {moment(item.CreatedOn).format("DD MMM YY")}, Size: {item.Filesize}
                    </span>
                    <a
                      href={item.SASFilepath}
                      download={item.Filename}
                      className="close-btn download-btn"
                      title="Download"
                      style={{ right: "21px" }}
                      onClick={() => toastSuccess(`${item.Filename} downloaded successfully`)}
                      tabIndex={0}
                    >
                      <FaDownload aria-hidden="true"/>
                    </a>

                    {RoleSplit(item.Rolename) === userProfile?.role && (
                      <button
                        className="close-btn attach-del-btn"
                        title="delete"
                        tabIndex={0}
                        onClick={() => deleteConfirm(item)}
                      >
                        <FaTrash aria-hidden="true"/>
                      </button>
                    )}
                  </div>
                  {/* {item.comment && (
                  <div className="attachment-comment">
                    <strong>Comment:</strong> {item.comment}
                  </div>
                )} */}
                </div>
                <div className="attachment-comment">
                  <p aria-label={`attachment type:${item.AttachType}`} tabIndex={0}><label>Type: </label>{getAttachmentTypeDisplay(item.AttachType)}</p>
             {item.Remarks && item.Remarks.length !== 0 ? (
                  <p
                    aria-label={`attachment comment:${item.Remarks}`}
                    tabIndex={0}
                    onKeyDown={e => {
                      if (e.key === 'Tab' && !e.shiftKey) {
                        e.preventDefault();
                        // Try to focus the TOC tab by id
                        const tocBtn = document.getElementById('toc-tab-btn');
                        if (tocBtn) tocBtn.focus();
                      }
                    }}
                  >
                    <label>Comment:</label>
                    <span dangerouslySetInnerHTML={{ __html: item.Remarks }} />
                  </p>
                ) : null}
                {alttextEnabled && item.altTextGeneration !== "null" ? (
                  <p aria-label={`alternative text generation:${item.altTextGeneration}`} tabIndex={0}>
                    <label>Alt Text Generation:</label>
                    <span>{item.altTextGeneration === 'yes' ? 'Yes' : 'No'}</span>
                  </p>
                ) : ''}
                </div>
              </div>
            ))
          ) : (
            <NodataFound />
          )}

        </section>
      </div>
    </div>
  );
}

export default Attachment_Sidebar;

